/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './habits-history.reducer';

export const HabitsHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const habitsHistoryEntity = useAppSelector(state => state.habitsHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="habitsHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.habitsHistory.detail.title">HabitsHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.id}</dd>
          <dt>
            <span id="habits">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.habits">Habits</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.habits}</dd>
          <dt>
            <span id="habitComment">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.habitComment">Habit Comment</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.habitComment}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.habitsHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{habitsHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.habitsHistory.patient">Patient</Translate>
          </dt>
          <dd>{habitsHistoryEntity.patient ? habitsHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/habits-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/habits-history/${habitsHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HabitsHistoryDetail;
